export const OpenLibraryBtn = () => {
    return (
        <a href="http://library.ahnyarinstitute.org/" target="_blank" rel="noreferrer" className="mx-1">
            <button
                className="btn btn-sm btn-primary rounded-pill m-1"
                type="button"
                style={{
                position: 'relative',
                zIndex: 1,
                transition: 'all 0.3s ease-in-out',
                }}
            >
                <span className="m-2">e-Library</span>
            </button>
        </a>
    )
}
